import React from "react";
import SeoHead from "@/components/SeoHead";

/**
 * Shared shell for legal / policy pages. Mirrors the About page's layout so
 * the whole site feels consistent. Body content is plain JSX so we can mix
 * headings, paragraphs, and lists naturally.
 */
export const LegalPage = ({ eyebrow, title, description, canonical, lastUpdated, children, testId }) => (
  <div className="App min-h-screen" data-testid={testId}>
    <SeoHead title={`${title} — Kerala Speaks`} description={description} canonical={canonical} />
    <section className="max-w-3xl mx-auto px-5 sm:px-6 md:px-12 pt-10 md:pt-16 pb-20">
      <p
        className="text-xs md:text-sm uppercase font-bold tracking-[0.4em] text-neutral-600 mb-5"
        data-testid={`${testId}-eyebrow`}
      >
        ★ {eyebrow} ★
      </p>
      <h1
        className="font-display uppercase leading-[0.85] tracking-tighter"
        style={{ fontSize: "clamp(2.5rem, 7vw, 5rem)" }}
        data-testid={`${testId}-title`}
      >
        {title}
      </h1>
      {lastUpdated && (
        <p className="text-[10px] uppercase font-bold tracking-[0.3em] text-neutral-500 mt-4">
          Last updated: {lastUpdated}
        </p>
      )}
      <div className="legal-prose mt-8 space-y-5 text-base md:text-lg font-medium leading-relaxed">
        {children}
      </div>
    </section>
  </div>
);

export const H2 = ({ children }) => (
  <h2 className="font-display uppercase tracking-tight text-xl md:text-2xl mt-8 mb-2 leading-tight" style={{ color: "#0A0A0A" }}>
    {children}
  </h2>
);

export const P = ({ children }) => (
  <p className="text-base md:text-lg leading-relaxed">{children}</p>
);

export const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 text-base md:text-lg leading-relaxed marker:text-[#FF9933]">
    {children}
  </ul>
);

export default LegalPage;
